module.exports = __webpack_public_path__ + "img/icon_member_off.fea7d631.svg";